<template>
  <b-container :class="`${type}-container`">
    <nuxt-link :to="link">
      <img :src="image" class="image mw-100" :alt="name" loading="lazy" />
      <div class="bottom-container" :class="{ 'p-3': typeCollection }">
        <div
          class="grouper-flex-container"
          :class="{ 'px-3': typeNichesOrTopics, 'style-content': typeStyles }"
        >
          <img
            v-if="typeStyles"
            :src="icon"
            :alt="`${name} thumbnail`"
            class="icon"
            loading="lazy"
          />
          <h3 class="name" :class="type">{{ name }}</h3>
          <p v-if="!typeStyles" class="total-contents">{{ totalContentsText }}</p>
        </div>
        <div v-if="typeCollection" class="see-more">
          {{ $t('main.groupers.collections.button') }}
        </div>
      </div>
    </nuxt-link>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    totalContents: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapGetters('niches', ['getNichesName', 'getTopicsName']),
    ...mapGetters('styles', ['getStylesName']),
    ...mapGetters('collections', ['getCollectionName']),
    typeNichesOrTopics() {
      return this.type === this.getNichesName || this.type === this.getTopicsName;
    },
    typeStyles() {
      return this.type === this.getStylesName;
    },
    typeCollection() {
      return this.type === this.getCollectionName;
    },
    totalContentsText() {
      return `${this.totalContents} ${this.$t('main.groupers.categories.designs')}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin: 1.5rem 0;
  padding: 0;
  width: 300px;
}

.grouper-flex-container {
  flex: 1;
  padding: 8px 0;
}
.bottom-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  .see-more {
    font-size: 11px;
    padding: 3px 13px;
    color: $strongGray;
    border-color: $strongGray;
    white-space: nowrap;
    background-color: #fff;
    border-radius: 23px;
    border: 1px solid;
    font-weight: 400;
  }
  .see-more:hover {
    color: #fff;
    background-color: #3e80f0;
    border-color: #fff;
  }
  #app.design .see-more:hover {
    background-color: $defaultColor;
  }
  #app.merch .see-more:hover {
    background-color: $defaultColor;
  }
}
.topics-container,
.niches-container {
  box-shadow: 0px 0px 10px 0px rgb(209, 200, 209);
  border-radius: 10px;
}
.style-container img {
  box-shadow: 0px 0px 10px 0px rgb(209, 200, 209);
}
.collection-container {
  .bottom-container {
    margin-top: 0px;
  }
  .grouper-flex-container {
    padding: 0;
  }
  .image {
    border-radius: 4px;
  }
  .total-contents {
    margin: 0;
    font-size: 10px;
    color: #575757;
  }
  &:hover {
    border-radius: 7px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.10196);
    .see-more {
      color: #fff;
      background-color: var(--exp-color);
      border: none;
    }
  }
}
.image {
  height: auto;
  width: 300px;
  border-radius: 10px;
}
.icon {
  width: 30px;
  height: 30px;
  clip-path: circle(15px at center);
}
.small-text {
  font-size: 0.7em;
  color: $strongGray;
}
.name {
  color: $strongGray;
  font-size: 0.8em;
  font-weight: 500;
}
.name.collection,
.name.topics,
.name.niches {
  color: #000;
  font-size: 1em;
  font-weight: 500;
}
.name.collection {
  margin-bottom: 5px;
}
.total-contents {
  font-size: 12px;
  color: $gray;
  margin-top: 6px;
}
.style-content {
  display: flex;
  align-items: center;
  h3 {
    margin: 0 0 0 10px;
  }
}
@media (max-width: 992px) {
  .container {
    width: 250px;
  }
  .image {
    height: 250px;
  }
}
@media (max-width: 576px) {
  .container {
    width: 300px;
  }
  .image {
    height: 300px;
  }
}
</style>
